import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./axios";
import VueAxios from "vue-axios";
// import $ from '/node_modules/jquery/dist/jquery.min.js'; // i just added it using CDN on /public/index.html into head tag

import "bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import "./js/global.js";
import "./css/front-style.css";
import "./css/front-style-rtl.css";
import { createI18n } from "vue-i18n";
import AR from "./locale/ar.json";
import EN from "./locale/en.json";

library.add(fas, far);

/** localization config code */
const LANG = getCookie("local") ?? "ar";
const DIR = LANG == "ar" ? "rtl" : "ltr";
const i18n = createI18n({
  locale: LANG,
  fallbackLocale: "ar",
  messages: {
    ar: AR,
    en: EN,
  },
});
document.querySelector("html").setAttribute("lang", LANG);
document.querySelector("html").setAttribute("dir", DIR);
/**********************/

/** Global functions */
/** */
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
/***************/
/** */
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
/***************/
/** */
function eraseCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}
/***************/

/**********************************/
const app = createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(store)
  .use(router)
  .use(VueAxios, axios)
  .use(i18n);
app.config.globalProperties.$token = "";
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$caretIcon = "caret-down";
app.config.globalProperties.$appType = {
  desc :["", "خروج من ليبيا", "دخول إلى ليبيا"],
  title :["", "تصدير مؤقت", "استيراد مؤقت"],
  full :["", "تصدير مؤقت (خروج من ليبيا)", "استيراد مؤقت (دخول إلى ليبيا)"],
};
app.config.globalProperties.$appStatus = [
  [],
  [
    { text: "تم رفض هذا الطلب", class: "text-danger" },
    { text: "الطلب في الانتظار (يمكنك التوجه للمعبر)", class: "text-secondary" },
    { text: "تم قبول الطلب", class: "text-primary" },
    { text: "أنهيت إجراءات العودة", class: "text-success" },
    { text: "أنهيت إجراءات العودة (استثناء)", class: "text-success" },
    { text: "تم اسقاط المركبة (استثناء)", class: "text-warning" },
  ],
  [
    { text: "تم رفض هذا الطلب", class: "text-danger" },
    { text: "الطلب في الانتظار (يمكنك التوجه للمعبر)", class: "text-secondary" },
    { text: "تم قبول الطلب", class: "text-primary" },
    { text: "أنهيت إجراءات العودة", class: "text-success" },
    { text: "أنهيت إجراءات العودة (استثناء)", class: "text-success" },
    { text: "تم اسقاط المركبة (استثناء)", class: "text-warning" },
  ],
];
app.config.globalProperties.$adminAppStatus = [
  [],
  [
    { text: "تم رفض هذا الطلب", class: "text-danger" },
    { text: "انتظار (تصدير مؤقت)", class: "text-secondary" },
    { text: "مقبول (خارج البلاد)", class: "text-primary" },
    { text: "أنهى إجراءاته (عاد إلى ليبيا)", class: "text-success" },
    { text: "أنهى إجراءاته (بمحضر استدلال)", class: "text-success" },
    { text: "تم اسقاط المركبة (استثناء)", class: "text-warning" },
  ],
  [
    { text: "تم رفض هذا الطلب", class: "text-danger" },
    { text: "انتظار (استيراد مؤقت)", class: "text-secondary" },
    { text: "مقبول (داخل ليبيا)", class: "text-primary" },
    { text: "أنهى إجراءاته (عاد إلى الخارج)", class: "text-success" },
    { text: "أنهى إجراءاته (بمحضر استدلال)", class: "text-success" },
    { text: "تم اسقاط المركبة (استثناء)", class: "text-warning" },
  ],
];
/** myGlobalFuncs */
/** */
app.config.globalProperties.$tempAlert = function (
  text,
  type = "warning",
  duration = 4000
) {
  var alert =
      `<div class='alert alert-` +
      type +
      ` alert-dismissible temp-alert'>` +
      text +
      `
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>`,
    contId = "alert-" + Math.floor(Math.random() * 10000);
  $("<div>", { class: "temp-alert-container", id: contId })
    .html(alert)
    .appendTo("body")
    .slideDown(300);
  setTimeout(function () {
    $("#" + contId).slideUp(500, function () {
      $(this).remove();
    });
  }, duration);
};
/**********************/
/********************************************/
// app.config.globalProperties.$ = $; //I just added it using CDN on /public/index.html into head tag
// Global Mixin
// app.mixin({
//     mounted() {
//      /** hide and show elements that has 'is-hidden' class by element has 'switcher' data-visibility attr*/
//    var targetVisId;
//    $("[data-visibility='switcher']").click(function(){
//        targetVisId = $(this).attr("data-vis-Id");
//        if($("[data-target-vis-Id='"+ targetVisId +"']").hasClass("is-hidden")){
//            $("[data-target-vis-Id='"+ targetVisId +"']").slideDown(250).removeClass("is-hidden");
//            $(this).children(".switcher-text").children("svg").removeClass("fas fa-caret-down").addClass("fas fa-caret-up");
//            // self.$caretIcon = "caret-up"
//        }else{
//            $("[data-target-vis-Id='"+ targetVisId +"']").slideUp(250).addClass("is-hidden");
//            $(this).children(".switcher-text").children("svg").removeClass("fas fa-caret-up").addClass("fas fa-caret-down");
//            // self.$caretIcon = "caret-down"

//        }

//   });
//   /*************************************************/
//     }
//   });
app.mount("#app");
